module.exports = __webpack_public_path__ + "img/36b)Hotel Dominican-Montage der öffentlichen Bereiche.jpg";